import { identity } from 'lodash'

import {
  SET_HIERARCHY_LEVELS,
  EDIT_HIERARCHY_LEVEL,
  LOAD_HIERARCHY,
} from '../constants/ActionTypes'
import selectors from '../selectors'

/**
 * @typedef {import('../index').HierarchyLevel} HierarchyLevel
 * @typedef {import('../index').Dispatch} Dispatch
 * @typedef {import('../index').GetState} GetState
 * @typedef {import('../index').HierarchyLevels} PlottrFileHierarchyLevels
 * @typedef {import('../index').PlottrFileBeatsEntry} PlottrFileBeatsEntry
 * @typedef {import('../types/plottr').HierarchyLevels} HierarchyLevels
 */

/**
 * @typedef {{ type: 'SET_HIERARCHY_LEVELS', hierarchyLevels: Array<HierarchyLevel>, timeline: number | 'series', newBeatTreeForCurrentTimeline: PlottrFileBeatsEntry, oldBeatTree: PlottrFileBeatsEntry, existingHierarchyLevelCount: number }} SetHierarchyLevelsAction
 */

/**
 * @typedef {ReturnType<typeof _editHierarchyLevel> | ReturnType<typeof load> | SetHierarchyLevelsAction} HierarchyActions
 */

const { currentTimelineSelector } = selectors(identity)

/**
 * @param {Array<HierarchyLevel>} hierarchyLevels
 * @param {number | 'series'} timeline
 * @return {{ type: 'SET_HIERARCHY_LEVELS', hierarchyLevels: Array<HierarchyLevel>, timeline: number | 'series' }}
 */
export const _setHierarchyLevels = (hierarchyLevels, timeline) => {
  return {
    type: SET_HIERARCHY_LEVELS,
    hierarchyLevels,
    timeline,
  }
}

/**
 * @param {Array<HierarchyLevel>} newHierarchyLevels
 * @return {function(Dispatch, GetState): Void}
 */
export const setHierarchyLevels = (newHierarchyLevels) => (dispatch, getState) => {
  const state = getState()
  const timeline = currentTimelineSelector(state)

  dispatch(
    // NOTE(ed): We add attributes in the root reducer
    //
    // @ts-ignore
    _setHierarchyLevels(newHierarchyLevels, timeline)
  )
}

/**
 * @param {0 | 1 | 2} level
 * @param {Partial<HierarchyLevel>} hierarchyLevel
 * @param {number | 'series'} timeline
 * @return {{ type: 'EDIT_HIERARCHY_LEVEL', level: 0 | 1 | 2, hierarchyLevel: Partial<HierarchyLevel>, timeline: number | 'series' }}
 */
export const _editHierarchyLevel = (level, hierarchyLevel, timeline) => {
  return {
    type: EDIT_HIERARCHY_LEVEL,
    level,
    hierarchyLevel,
    timeline,
  }
}

/**
 * @param {0 | 1 | 2} level
 * @param {Partial<HierarchyLevel>} hierarchyLevel
 * @return {function(Dispatch, GetState): Void}
 */
export const editHierarchyLevel = (level, hierarchyLevel) => (dispatch, getState) => {
  const state = getState()
  const timeline = currentTimelineSelector(state)

  dispatch(_editHierarchyLevel(level, hierarchyLevel, timeline))
}

/**
 * @param {boolean} patching
 * @param {PlottrFileHierarchyLevels} hierarchy
 * @return {{ type: 'LOAD_HIERARCHY', patching: boolean, hierarchy: PlottrFileHierarchyLevels }}
 */
export const load = (patching, hierarchy) => {
  return {
    type: LOAD_HIERARCHY,
    patching,
    hierarchy,
  }
}
